import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingKalkulacePage = lazy(() =>
  import('@/modules/leasing/LeasingKalkulace').then((m) => ({ default: m.LeasingKalkulacePage })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/$id/kalkulace',
  component: () => (
    <Suspense fallback={null}>
      <LeasingKalkulacePage />
    </Suspense>
  ),
});
